<template>
  <div class="card">
    <div class="card-body">
      <div class="card-title">
        <h5>
          <router-link
            v-slot="{ href, navigate }"
            :to="{
              name: 'activity/RotaActivityView',
              params: { rotaActivityId: activity.id },
            }"
            custom
          >
            <a
              :href="href"
              @click="onTitleClick($event)"
              @keypress.enter="navigate"
            >
              <span v-if="startDay" class="activity-day me-1">
                {{ startDay }}
              </span>
              <span class="activity-time me-1">
                {{ formatTimeHoursMins(activity.startDate) }}
              </span>
              <span class="activity-title" data-dd-privacy="mask">
                {{ activity.title }}
              </span>
            </a>
          </router-link>
        </h5>
        <client-badge
          :client="client"
          :show-location="false"
          :show-room-number="true"
          class="d-flex align-items-end justify-content-between"
        />
      </div>
      <challenging-behaviour-render-item
        :report="behaviourReport"
        :activity-id="activity.id"
        :client-id="client.clientId"
      />
    </div>
  </div>
</template>

<script>
import { isBefore, startOfDay, format } from "date-fns";
import { formatTimeHoursMins } from "../../lib/date-functions";
import {
  getFontAwesomeIconFromActivity,
  getActionIconIDText,
} from "../../lib/constants/pcs-functions";
import ClientBadge from "../ui/ClientBadge.vue";
import usePopupActivity from "./usePopupActivity";
import ChallengingBehaviourRenderItem from "./report/ChallengingBehaviourRenderItem.vue";

export default {
  components: {
    ClientBadge,
    ChallengingBehaviourRenderItem,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
    client: {
      type: Object,
      required: true,
    },
    behaviourReport: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { showViewActivityPopup } = usePopupActivity();

    function onTitleClick(event) {
      event.preventDefault();
      event.stopPropagation();
      showViewActivityPopup({ rotaActivity: props.activity });
    }
    return {
      formatTimeHoursMins,
      getFontAwesomeIconFromActivity,
      getActionIconIDText,
      onTitleClick,
    };
  },
  computed: {
    startDay() {
      const { startDate } = this.activity;
      const today = new Date();
      return isBefore(startDate, startOfDay(today))
        ? format(startDate, "E")
        : "";
    },
  },
};
</script>
